import { useSelector } from 'react-redux';
import { selectPrivacyConsent } from '../../../../redux/config/selectors';
import { useHistory } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { internalRoutePaths } from '../../../../config/config';

const usePrivacyConsent = ({ skip }) => {
  const history = useHistory();
  const privacyConsent = useSelector(selectPrivacyConsent);

  const shouldShowPrivacyConsent = useMemo(() => {
    return !privacyConsent?.consent_signed || privacyConsent?.outdated;
  }, [privacyConsent]);

  useEffect(() => {
    if (!privacyConsent || skip) return;

    if (shouldShowPrivacyConsent) {
      history.push(internalRoutePaths.PRIVACY_CONSENT);
    } else {
      //in case user go direclty to the route relocate to workspaces
      if (history?.location?.pathname === internalRoutePaths.PRIVACY_CONSENT) {
        history.push(internalRoutePaths.WORKSPACES);
      }
    }
  }, [history, shouldShowPrivacyConsent, privacyConsent, skip]);

  return {
    shouldShowPrivacyConsent,
  };
};

export default usePrivacyConsent;
